import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppRouterState } from './router-state';
import { StateSlice } from '../state-slice';

export const selectRouterState = createFeatureSelector<IAppRouterState>(StateSlice.ROUTER);

export const getRouterState = createSelector(selectRouterState, (state: IAppRouterState) => state);